enum TimelineEvents {
    // スタジオ・未編集のフッテージ一覧取得
    GetUneditedFootagesStarted = "[TimelineEvents] GetUneditedFootagesStarted",
    GetUneditedFootagesComplete = "[TimelineEvents] GetUneditedFootagesComplete",

    // タイムライン取得
    GetTimelinesStarted = "[TimelineEvents] GetTimelinesStarted",
    GetTimelinesComplete = "[TimelineEvents] GetTimelinesComplete",

    // 直近のフッテージ取得
    GetRecentFootagesStarted = "[TimelineEvents] GetRecentFootagesStarted",
    GetRecentFootagesComplete = "[TimelineEvents] GetRecentFootagesComplete",

    // タイムライン作成
    CreateTimelineStarted = "[TimelineEvents] CreateTimelineStarted",
    CreateTimelineComplete = "[TimelineEvents] CreateTimelineComplete",
    CreateTimelineFailed = "[TimelineEvents] CreateTimelineFailed",

    // タイムライン削除
    DeleteTimelineStarted = "[TimelineEvents] DeleteTimelineStarted",
    DeleteTimelineComplete = "[TimelineEvents] DeleteTimelineComplete",

    //タイムライン取得
    GetTimelineStarted = "[Timeline] GetTimelineStarted",
    GetTimelineComplete = "[Timeline] GetTimelineComplete",
    GetTimelineFailed = "[Timeline] GetTimelineFailed",

    // タイムライン再生開始
    PlayTimeline = "[Timeline] PlayTimeline",

    // タイムライン再生一時停止
    PauseTimeline = "[Timeline] PauseTimeline",

    // タイムライン再生終了
    FinishTimeline = "[Timeline] FinishTimeline",

    // タイムラインのリプレイ
    ReplayTimeline = "[Timeline] ReplayTimeline",

    // タイムラインのリセット
    ResetTimeline = "[Timeline] ResetTimeline",

    // タイムライン時間更新
    UpdateTimelinePlayInfo = "[Timeline] UpdateTimelinePlayInfo",

    // タイムラインの編集ショートカットキー番号を更新
    UpdateTimelineShootCutKeyId = "[Timeline] UpdateTimelineShootCutKeyId",

    // タイムライン再生中のクリップINDEXを更新
    UpdateTimelineSourceIndex = "[Timeline] UpdateTimelineSourceIndex",

    // タイムラインのkeyboardでvideo再生をコントロールするかどうか
    SetIsHandleKeyboard = "[Timeline] SetIsHandleKeyboard",

    // タイムライン編集のUNDO、REDO
    UpdateTimelineClipList = "[Timeline] UpdateTimelineClipList",
    UpdateTimelineClipListComplete = "[Timeline] UpdateTimelineClipListComplete",

    // 書き出し完了したタイムラインをcineonhubにアップロード
    UploadTimelineStarted = "[Timeline] UploadTimelineStarted",
    UploadTimelineComplete = "[Timeline] UploadTimelineComplete",
    UploadTimelineFailed = "[Timeline] UploadTimelineFailed",

    //フッテージリスト取得
    GetFootageListStarted = "[Timeline] GetFootageListStarted",
    GetFootageListComplete = "[Timeline] GetFootageListComplete",

    //フッテージ動画取得
    GetFootageVideoStarted = "[Timeline] GetFootageVideoStarted",
    GetFootageVideoComplete = "[Timeline] GetFootageVideoComplete",

    //サムネイル取得
    GetThumbnailStarted = "[Timeline] GetThumbnailStarted",
    GetThumbnailComplete = "[Timeline] GetThumbnailComplete",

    //利用可能ディレクトリリスト取得
    GetUsableDirListStarted = "[Timeline] GetUsableDirListStarted",
    GetUsableDirListComplete = "[Timeline] GetUsableDirListComplete",

    //クリップ追加
    AddClipToTimelineStarted = "[Timeline] AddClipToTimelineStarted",
    AddClipToTimelineComplete = "[Timeline] AddClipToTimelineComplete",

    //クリップ移動
    ClipMoveStarted = "[Timeline] ClipMoveStarted",
    ClipMoveComplete = "[Timeline] ClipMoveComplete",

    //クリップを削除
    DeleteClipStarted = "[Timeline] DeleteClipStarted",
    DeleteClipComplete = "[Timeline] DeleteClipComplete",

    //クリップの分割
    CutClipStarted = "[Timeline] CutClipStarted",
    CutClipComplete = "[Timeline] CutClipComplete",
    CutClipFailed = "[Timeline] CutClipFailed",

    // アップロードキャンセル
    UpdateTimelineStatus = "[Timeline] UpdateTimelineStatus",
    UpdateTimelineStatusCompleted = "[Timeline] UpdateTimelineStatusCompleted",

    //クリップの編集
    EditClipStarted = "[Timeline] EditClipStarted",
    EditClipComplete = "[Timeline] EditClipComplete",

    // タイライム名変更
    RenameTimelineStarted = "[Timeline] RenameTimelineStarted",
    RenameTimelineComplete = "[Timeline] RenameTimelineComplete",
}
export default TimelineEvents;
